/*global $ */

import { backfaceFixed } from "./backfaceFixed";

class ProfileModal {
  constructor() {
    console.log("ProfileModal");
    this.$container = $(".ProfileModal");
    this.isOpen = false;

    this.$cards = [];

    this.$container.find(".ProfileCard").each((i, e) => {
      this.$cards.push($(e));
    });

    $(".js-open-profile-modal").on("click", (e) => {
      if (!this.isOpen) {
        this.fadein($(e.currentTarget).attr("data-index"));
      }
    });

    $(".BtnProfileCardClose").on("click", () => {
      if (this.isOpen) {
        this.fadeout();
      }
    });
  }
  /*
  openOverlayPanel() {
    if (!this.isOpen) {
      this.isOpen = true;
      backfaceFixed(true);
    }
  }
  closeOverlayPanel() {
    if (this.isOpen) {
      this.isOpen = false;
      backfaceFixed(false);
    }
  }*/
  fadein(index) {
    if (!this.isOpen) {
      this.isOpen = true;
      backfaceFixed(true);
      for (let i = 0; i < this.$cards.length; i++) {
        if (this.$cards[i].attr("data-index") == index) {
          this.$cards[i].css("display", "flex");
        } else {
          this.$cards[i].css("display", "none");
        }
      }
      this.$container
        .stop(false)
        .css({
          opacity: 0,
          display: "flex",
        })
        .animate({ opacity: 1 }, 400, "easeOutSine", () => {});
    }
  }
  fadeout() {
    if (this.isOpen) {
      this.isOpen = false;
      backfaceFixed(false);
      this.$container
        .stop(false)
        .animate({ opacity: 0 }, 400, "easeOutExpo", () => {
          this.$container.css("display", "none");
        });
    }
  }
}

export default ProfileModal;
